import React, { useState, useEffect } from "react";
import withForm from "withForm";
import { loginFormConfig } from "config/loginPage";
import { compose } from "redux";
import { useAuthCenter } from "AuthCenter";
import { useNotificationCenter } from "NotificationCenter";
import { BaseForm } from "components/ui_components/Forms";
import { ButtonGroup } from "components/ui_components/buttons";
import ButtonBase from "@mui/material/ButtonBase";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { signOut } from 'aws-amplify/auth';

const LoginForm = ({ setDataLoading, ...props }) => {
  const [isMfaAuth, setIsMfaAuth] = useState(
    process.env.REACT_APP_HOST_ENV === "prod"
  );
  const {
    isFormValid,
    resetErrors,
    getSubmitData,
    inputsById,
    inputsByHash,
    handleInputs,
  } = props;
  const authCenter = useAuthCenter();
  const notificationCenter = useNotificationCenter();
  const navigate = useNavigate();

  // Clear any stale Cognito session on mount
  useEffect(() => {
    const clearCognitoSession = async () => {
      try {
        await signOut();
      } catch (e) {
        // Silent fail - session may not exist
        console.log('No active Cognito session to clear');
      }
    };
    clearCognitoSession();
  }, []);

  // Cleanup effect
  useEffect(() => {
    return () => {
      setDataLoading(false);
    };
  }, [setDataLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isFormValid()) {
      resetErrors();

      try {
        setDataLoading(true);
        if (isMfaAuth) {
          try {
            await authCenter.cognitoLogIn({ ...getSubmitData() });
            setDataLoading(false);
          } catch (err) {
            notificationCenter.show(err.message, "error");
            setDataLoading(false);
          }
        } else {
          try {
            await authCenter.oldLogIn({ ...getSubmitData() });
            notificationCenter.show("Successfully login");
            setDataLoading(false);
            navigate("/");
          } catch (err) {
            notificationCenter.show(err.message, "error");
            setDataLoading(false);
          }
        }
      } catch (e) {
        notificationCenter.show(e.message, "error");
        setDataLoading(false);
      }
    }
  };

  const handleIsMfaAuthCheckbox = (event) => {
    setIsMfaAuth(event.target.checked);
  };

  return (
    <React.Fragment>
      <form>
        <BaseForm
          inputsById={inputsById}
          inputsByHash={inputsByHash}
          handleInputs={handleInputs}
          inputWrapStyles={`width: 100%;`}
        />

        {process.env.REACT_APP_HOST_ENV !== "prod" && (
          <FormControlLabel
            control={
              <Checkbox
                checked={isMfaAuth}
                onChange={handleIsMfaAuthCheckbox}
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            }
            label="Use MFA auth"
            sx={{
              '& .MuiFormControlLabel-label': {
                fontFamily: 'Roboto',
                fontSize: '13.7143px',
                color: '#000000',
              }
            }}
          />
        )}
        <ButtonGroup rootStyles={"padding: 10px 0 0; text-align: right;"}>
          <Button
            color="primary"
            onClick={() => {
              authCenter.setAuthStatus("forgotPassword");
            }}
            sx={{
              fontFamily: 'Roboto',
              fontWeight: 500,
              lineHeight: 1.75,
              borderRadius: '4px',
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              color: '#004C6A',
            }}
          >
            Forgot Password
          </Button>
        </ButtonGroup>

        <ButtonGroup rootStyles={"padding: 20px 0 0; text-align: center;"}>
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            className="button formButton formButton__mainContained"
          >
            Login
          </ButtonBase>
        </ButtonGroup>
      </form>
    </React.Fragment>
  );
};

export default compose(withForm(loginFormConfig))(LoginForm);
